import React from 'react';
import styled from 'styled-components';

import { BREAK_POINTS } from '../../consts/style';
import { Slider, Slide } from '../Common/Slider';
import { SectionSidePadding } from '../Common';
import { SectionHeading } from '../Common/Headings';
import { Summary, Props as SummaryProps } from './Summary';
import { Review, Props as ReviewProps } from './Review';

import { useBFCacheHandler, useRerender } from '../Common/hooks/bfCache';

const Container = styled.div`
  display: block;
  width: 100%;
  margin: 0 auto;

  & .swiper > .swiper-wrapper {
    transition-timing-function: linear;
  }

  & .swiper-slide {
    width: 300px;
  }

  // fix for Chrome back button layout shift
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    min-height: 450px;
  }

  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    min-height: 508px;
  }
`;

type Props = { heading: string; summary: SummaryProps; reviews: ReviewProps[] };

const swiperProps = {
  slidesPerView: 'auto',
  centeredSlides: false,
  grabCursor: false,
  loop: true,
  keyboard: {
    enabled: false,
  },
  autoplay: {
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
    delay: 0,
  },
  speed: 5000,
  spaceBetween: 20,
  navigation: false,
  allowTouchMove: false,
};

export const TrustPilot = ({ summary, reviews, heading }: Props) => {
  // BF Cache fix for safari: Safari uses the bf cache which breaks
  // the slider when going back to it after clicking through to another
  // page. The simple fix for this is to just re-render the slider if
  // The BF cache was used to load the page.
  const [isSliderVisible, reRenderSlider] = useRerender();
  useBFCacheHandler(reRenderSlider);

  return (
    <Container>
      <SectionSidePadding>
        <SectionHeading heading={heading} />
        <Summary {...summary} />
      </SectionSidePadding>
      {isSliderVisible && (
        <Slider id="tp" swiperProps={swiperProps}>
          <>
            {reviews.map((review) => (
              <Slide key={review.id}>
                <Review {...review} />
              </Slide>
            ))}
          </>
        </Slider>
      )}
    </Container>
  );
};
